module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-settings/147assets/fonts/448c34a56d699c29117adc64c43affeb.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.woff2
// module id = 755
// module chunks = 4